// extracted by mini-css-extract-plugin
export default {"navigation":"Brands_navigation__CgfbE","title":"Brands_title__m8zCb","banner__navigation":"Brands_banner__navigation__GbU3i"};